import { render } from "./EPBusiness.vue?vue&type=template&id=677dff69&scoped=true"
import script from "./EPBusiness.vue?vue&type=script&lang=js"
export * from "./EPBusiness.vue?vue&type=script&lang=js"

import "./EPBusiness.vue?vue&type=style&index=0&id=677dff69&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677dff69"]])

export default __exports__